import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch, apiMutate } from "@/lib/api";

export interface SharedConversation {
  title: string;
  model: string;
  message_count: number;
  created_at: string;
  shared_by: string;
  messages: Array<{
    id: string;
    role: "user" | "assistant";
    content: string;
    model: string | null;
    tool_calls: Array<{
      tool: string;
      input: Record<string, unknown>;
      output: unknown;
    }> | null;
    tool_call_count: number;
    duration_ms: number | null;
    created_at: string;
  }>;
}

export function useSharedConversation(token: string | null) {
  return useQuery({
    queryKey: ["shared", token],
    queryFn: () => apiFetch<SharedConversation>(`/api/sharing/${token}`),
    enabled: token !== null,
  });
}

export function useCreateShareLink() {
  return useMutation({
    mutationFn: (data: { conversation_id: string; message_id?: string }) =>
      apiMutate<{ id: string; share_token: string; url: string }>(
        "/api/sharing",
        "POST",
        data
      ),
  });
}
